import { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import RoutesList from './routing/Routes';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <Router>
      <Suspense fallback={<div>LOADING.....</div>}>
        <RoutesList />
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Suspense>
    </Router>
  );
}

export default App;
